"use client";

import { Check, X } from "lucide-react";

interface ProsConsSectionProps {
  labelA: string;
  labelB: string;
  prosA: string[];
  consA: string[];
  prosB: string[];
  consB: string[];
}

export default function ProsConsSection({
  labelA,
  labelB,
  prosA,
  consA,
  prosB,
  consB,
}: ProsConsSectionProps) {
  return (
    <div className="pros-cons-container">
      {/* Product A */}
      <div className="product-block">
        <h3 className="product-title">{labelA} Pros & Cons</h3>
        <div className="list-grid">
          <div className="pros-list">
            <h4 className="list-title text-success">Advantages of {labelA}</h4>
            <ul>
              {prosA.map((item, idx) => (
                <li key={idx} className="list-item">
                  <Check size={14} className="icon-check" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="cons-list">
            <h4 className="list-title text-danger">Disadvantages of {labelA}</h4>
            <ul>
              {consA.map((item, idx) => (
                <li key={idx} className="list-item">
                  <X size={14} className="icon-x" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Product B */}
      <div className="product-block">
        <h3 className="product-title">{labelB} Pros & Cons</h3>
        <div className="list-grid">
          <div className="pros-list">
            <h4 className="list-title text-success">Advantages of {labelB}</h4>
            <ul>
              {prosB.map((item, idx) => (
                <li key={idx} className="list-item">
                  <Check size={14} className="icon-check" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="cons-list">
            <h4 className="list-title text-danger">Disadvantages of {labelB}</h4>
            <ul>
              {consB.map((item, idx) => (
                <li key={idx} className="list-item">
                  <X size={14} className="icon-x" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <style jsx>{`
        .pros-cons-container {
          display: flex;
          flex-direction: column;
          gap: var(--space-6);
        }
        .product-block {
          background-color: var(--bg-surface);
          border: 1px solid var(--border-color);
          border-radius: var(--radius-md);
          padding: var(--space-5);
        }
        .product-title {
          font-family: var(--font-heading);
          font-size: var(--text-lg);
          color: var(--text-secondary);
          font-weight: var(--fw-extrabold);
          margin-bottom: var(--space-4);
          border-bottom: 1px solid var(--border-color);
          padding-bottom: var(--space-2);
        }
        .list-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: var(--space-5);
        }
        @media (max-width: 768px) {
          .list-grid {
            grid-template-columns: 1fr;
            gap: var(--space-4);
          }
        }
        .list-title {
          font-family: var(--font-heading);
          font-size: var(--text-sm);
          font-weight: var(--fw-extrabold);
          margin-bottom: var(--space-3);
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }
        .text-success {
          color: var(--primary);
        }
        .text-danger {
          color: var(--danger);
        }
        ul {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: var(--space-3);
        }
        .list-item {
          display: flex;
          align-items: flex-start;
          gap: var(--space-2);
          font-family: var(--font-body);
          font-size: var(--text-sm);
          line-height: 1.4;
          color: var(--text-secondary);
          font-weight: var(--fw-semibold);
        }
        .icon-check {
          color: var(--primary);
          flex-shrink: 0;
          margin-top: 2px;
        }
        .icon-x {
          color: var(--danger);
          flex-shrink: 0;
          margin-top: 2px;
        }
      `}</style>
    </div>
  );
}
